var m = require('mithril');
var moment = require('moment');

var dateFormat = 'MM-DD-YYYY hh:mm:ss a';

var PointunitMap = {
  'tempF': '°F',
  'tempC': '°C',
  'temp-F': '°F',
  'temp-C': '°C',
  'degF': '°F',
  'degC': '°C',
  'percent': '%',
  'inH2O': 'wc',
  'int': '',
  'str': '',
  'datetime': '',
  'gal/min': 'gpm'
};

function getAuthEventUser(eventRecord) {
  var edge = eventRecord && Array.isArray(eventRecord.in_HadAuthEvent) && eventRecord.in_HadAuthEvent[0];
  return edge && edge.out ? edge.out : null;
}

function userLabel(user) {
  if (!user) return '';
  return `${user.firstName || ''} ${user.lastName || ''}`.trim();
}

function formatUser(eventRecord) {
  if (!eventRecord || !eventRecord['@rid']) return '';

  if (eventRecord['@class'] === 'Comment') {
    var author = eventRecord.out_AuthoredBy && eventRecord.out_AuthoredBy[0] && eventRecord.out_AuthoredBy[0].in;
    return userLabel(author);
  }

  if (eventRecord['@class'] === 'AuthEvent') {
    return userLabel(getAuthEventUser(eventRecord));
  }

  if (eventRecord['@class'] === 'Command' || eventRecord['@class'] === 'Override') {
    var firstName = eventRecord.properties && eventRecord.properties.firstName;
    var lastName = eventRecord.properties && eventRecord.properties.lastName;
    var name = `${firstName || ''} ${lastName || ''}`.trim();
    if (name) return name;
    return userLabel(eventRecord.user);
  }
  if (eventRecord['@class'] === 'ViewEvent') {
    return userLabel(eventRecord.user);
  }

  return userLabel(eventRecord.user);
}

function parseViewRoute(route) {
  var value = String(route || '').trim();
  if (!value) return null;
  var hashIndex = value.indexOf('#');
  if (hashIndex !== -1) {
    value = value.slice(hashIndex + 1);
  }
  if (value.charAt(0) === '!') {
    value = value.slice(1);
  }
  value = value.replace(/^https?:\/\/[^/]+/, '');
  var path = value.split('?')[0];
  if (path.charAt(0) !== '/') path = '/' + path;
  var segments = path.split('/').filter(Boolean);
  if (!segments.length) return null;

  if (segments[0] === 'dashboard' && segments[1]) {
    return { type: 'Dashboard', href: '#!/dashboard/' + segments[1], pathLabel: path };
  }
  if (segments[0] === 'location' && segments[1]) {
    return { type: 'Location', href: '#!/location/' + segments[1], pathLabel: path };
  }
  if (segments[0] === 'equipment' && segments[1] && segments[2]) {
    return { type: 'Equipment', href: '#!/equipment/' + segments[1] + '/' + segments[2], pathLabel: path };
  }

  return { type: '', href: '#!' + path, pathLabel: path };
}

function formatCommandValue(eventRecord) {
  var rawValue = eventRecord && eventRecord.properties && eventRecord.properties.value;
  var unit = eventRecord && eventRecord.object && eventRecord.object.unit
    ? (PointunitMap[eventRecord.object.unit] || eventRecord.object.unit)
    : '';

  if (rawValue === null || typeof rawValue === 'undefined' || rawValue === '') {
    return '---';
  }

  var numeric = parseFloat(rawValue);
  var formattedValue = Number.isNaN(numeric) ? String(rawValue) : numeric.toFixed(2);
  return `${formattedValue}${unit || ''}`;
}

function renderEventRow(eventRecord) {
  if (!eventRecord || !eventRecord['@rid']) {
    return m('tr', [
      m('td.bb.moon-gray.tl.nowrap.pr3',[
        m('label',{style:{'visibility':'hidden'}}, 'No Data')
      ]),
      m('td.bb.moon-gray.tl.nowrap.pr3'),
      m('td.bb.moon-gray.tl.nowrap.pr3'),
      m('td.bb.moon-gray.tl.nowrap.pr3'),
      m('td.bb.moon-gray.tl.nowrap.pr3'),
      m('td.bb.moon-gray.tl.nowrap.pr3'),
      m('td.bb.moon-gray.tl.nowrap.pr3'),
      m('td.bb.moon-gray.tl.nowrap.pr3')
    ]);
  }

  var valueCell = '';
  if (eventRecord['@class'] == 'Command' || eventRecord['@class'] == 'Override') {
    valueCell = formatCommandValue(eventRecord);
  } else if (eventRecord['@class'] == 'ViewEvent') {
    var viewRoute = parseViewRoute(eventRecord.route || eventRecord.url);
    valueCell = viewRoute && viewRoute.href
      ? m('a', {href: viewRoute.href}, viewRoute.pathLabel || viewRoute.href)
      : 'No URL';
  }

  return m('tr', [
    (()=>{
      if (eventRecord['@class'] == 'AlarmEvent') {
        return m('td.pr2.bb.bl-0.truncate', eventRecord.start ? moment(eventRecord.start).format(dateFormat) : '');
      } else {
        return m('td.pr2.bb.bl-0.truncate', eventRecord.timestamp ? moment(eventRecord.timestamp).format(dateFormat) : '');
      }
    })(),
    m('td.pr2.bb.bl-0.truncate', eventRecord['@class']),
    m('td.pr2.bb.bl-0.truncate', formatUser(eventRecord)),
    (()=>{
      if (eventRecord['@class'] == 'AlarmEvent') {
        return m('td.pr2.bb.bl-0.truncate', 'N / A');
      } else if (eventRecord['@class'] == 'Command' || eventRecord['@class'] == 'Override') {
        return m('td.pr2.bb.bl-0.truncate', `Command ${formatCommandValue(eventRecord)}`)
      } else if (eventRecord['@class'] == 'Comment') {
        return m('td.pr2.bb.bl-0.truncate', eventRecord.message || eventRecord.comment || eventRecord.text || '')
      } else if (eventRecord['@class'] == 'ViewEvent') {
        return m('td.pr2.bb.bl-0.truncate', `View`);
      } else{
        return m('td.pr2.bb.bl-0.truncate', eventRecord.type ? eventRecord.type : '');
      }
    })(),
    (()=>{
      if (eventRecord['@class'] == 'Incident') {
        return m('td.pr2.bb.bl-0.truncate', eventRecord.out_Of && eventRecord.out_Of[0] && eventRecord.out_Of[0].in ? eventRecord.out_Of[0].in['@class']: '')
      } else if (eventRecord['@class'] == 'AlarmEvent' || eventRecord['@class'] == 'CommFailure') {
        return m('td.pr2.bb.bl-0.truncate', `${eventRecord.object['@class']}`)
      } else if (eventRecord['@class'] == 'AuthEvent') {
        var authUser = getAuthEventUser(eventRecord);
        if (!authUser || !authUser['@rid']) {
          return m('td.pr2.bb.bl-0.truncate', userLabel(authUser));
        }
        return m('td.pr2.bb.bl-0.truncate', [
          m('a', {href: `#!/profile/${authUser['@rid'].slice(1)}`}, [
            userLabel(authUser)
          ])
        ])
      } else if (eventRecord['@class'] == 'Command' || eventRecord['@class'] == 'Override') {
        if (eventRecord.object && eventRecord.object['@class']) {
          return m('td.pr2.bb.bl-0.truncate', eventRecord.object['@class'])
        }
        return m('td.pr2.bb.bl-0.truncate', '')
      } else if (eventRecord['@class'] == 'Comment') {
        return m('td.pr2.bb.bl-0.truncate', [
          (function () {
            var subject = eventRecord.subjectRecord
              || (eventRecord.in_SubjectOf && eventRecord.in_SubjectOf[0] && eventRecord.in_SubjectOf[0].out)
              || null;
            if (!subject || !subject['@rid']) return '';
            var subjectClass = subject['@class'] || '';
            var subjectName = subject.name || subjectClass || 'Subject';

            if (subjectClass === 'Incident') {
              return m('div', 'Point')
            } else if (subjectClass && subject['@rid']) {
              let href = `#!/equipment/${subjectClass}/${subject['@rid'].slice(1)}`;
              return m('a', { href: href }, subjectName);
            }

          })()
        ])
      } else if (eventRecord['@class'] == 'ViewEvent') {
        var viewObject = eventRecord.object || null;
        var viewLabel = viewObject ? (viewObject.name || viewObject['@class']) : '';
        return m('td.pr2.bb.bl-0.truncate', viewLabel || '')
      } else {
        return m('td.pr2.bb.bl-0.truncate', '')
      }
    })(),
    (()=>{
      if (eventRecord['@class'] == 'Incident' ) {
        if (eventRecord.out_Of && eventRecord.out_Of[0] && eventRecord.out_Of[0].in) {
          return m('td.pr2.bb.bl-0.truncate', [
            m('a', {href: `#/point/${eventRecord.out_Of[0].in['@rid'].slice(1)}`}, [
              eventRecord.out_Of[0].in.path.map(function (ancestor, idx) {
                return m('div.mr2.dib.', [
                  ancestor.name,
                  (idx < (eventRecord.out_Of[0].in.path.length - 1) ? ' / ' : '')
                ]);
              })
            ])
          ])
        } else {
          return m('td.pr2.bb.bl-0.truncate', 'No path')
        }
      } else if (eventRecord['@class'] == 'Command' || eventRecord['@class'] == 'Override') {
        if (eventRecord.object.out_Source && eventRecord.object.out_Source[0] && eventRecord.object.out_Source[0].in) {
          return m('td.pr2.bb.bl-0.truncate', [
            m('a', {href: `#/point/${eventRecord.object['@rid'].slice(1)}`}, [
              eventRecord.object.path.map(function (ancestor, idx) {
                return m('div.mr2.dib.', [
                  ancestor.name,
                  (idx < (eventRecord.object.path.length - 1) ? ' / ' : '')
                ]);
              })
            ]),
          ])
        } else {
          return m('td.pr2.bb.bl-0.truncate', 'No path')
        }
      } else if (eventRecord['@class'] == 'AlarmEvent') {
        var objectRid = eventRecord.object && eventRecord.object['@rid']
          ? eventRecord.object['@rid']
          : (typeof eventRecord.object === 'string' ? eventRecord.object : null);
        var path = eventRecord.object && Array.isArray(eventRecord.object.path)
          ? eventRecord.object.path
          : [];

        if (!objectRid) {
          return m('td.pr2.bb.bl-0.truncate', 'No path');
        }

        return m('td.pr2.bb.bl-0.truncate', [
          m('a', {href: `#/location/${objectRid.slice(1)}`}, [
            path.length > 0 ? path.map(function (ancestor, idx) {
              return m('div.mr2.dib.', [
                ancestor.name == 'root' ? 'Home' : ancestor.name,
                (idx < (path.length - 1) ? ' / ' : '')
              ]);
            }) : m('span', objectRid)
          ])
        ])
      } else if (eventRecord['@class'] == 'CommFailure') {
        return m('td.pr2.bb.bl-0.truncate', [
          m('a', {href: `#/${eventRecord.path[0]["@class"].toLowerCase()}/${eventRecord.path[0]['@rid'].slice(1)}`}, [
            eventRecord.path.map(function (ancestor, idx) {
              return m('div.mr2.dib.', [
                ancestor.name,
                (idx < (eventRecord.path.length - 1) ? ' / ' : '')
              ]);
            })
          ]),
        ])
      } else if (eventRecord['@class'] == 'Comment') {
        let subject = eventRecord.in_SubjectOf[0].out;
        let pointRid = subject.path && subject.path.length > 0 ? subject.path[subject.path.length - 1]['@rid'] : null;
        if (subject['@class'] === 'Incident') {
          return m('td.pr2.bb.bl-0.truncate', [
            m('a', {href: `#/point/${pointRid.slice(1)}`}, [
              subject.path.map(function (ancestor, idx) {
                return m('div.mr2.dib.', [
                  ancestor.name,
                  (idx < (subject.path.length - 1) ? ' / ' : '')
                ]);
              })
            ])
          ]);
        } else {
          return m('td.pr2.bb.bl-0.truncate', [
            subject.path && subject.path.length > 0 ?
              m('div.flex', [
                subject.path.map(function (ancestor, idx) {
                  return [
                    m(`a.mr2.dib.${idx > 0 ? '.ml2' : ''}`, {href: `#/location/${ancestor['@rid'].slice(1)}`}, [
                      ancestor.name == 'root' ? 'Home' : ancestor.name,
                    ]),
                    (idx < (subject.path.length - 1) ? ' / ' : '')
                  ]
                })
              ]) :
              m('div.mr2.dib.', 'No path')
            ]);
        }
      } else if (eventRecord['@class'] == 'ViewEvent') {
        return m('td.pr2.bb.bl-0.truncate', 'No Path');
      } else {
        return m('td.pr2.bb.bl-0.truncate', 'No path')
      }
    })(),
    m('td.pr2.bb.bl-0.truncate', valueCell || '—'),
    m('td.bb.bl-0.pr2.truncate')
  ]);
}

module.exports = renderEventRow;
